import type { ResultOf } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";

export const query = graphql(`
    query TasksSidebarLearningPathQuery($id: ID!) {
        learningPath(id: $id) {
            id
            learningPathItems {
                id
                type
                locked
                lockedType
                title
                miles
                earnedMiles
                icon
                url
                complete
                active
                undecided
                redo
                callToAction
                deadline
                finishDatetime
                shareAnswers
                pathInPath {
                    id
                }
                taskChoice {
                    id
                }
                event {
                    id
                    eventStart
                }
                feedbackTask {
                    id
                }
                tasks {
                    id
                    doInGroup
                    icon
                    miles
                    shortTitle
                    taskVariants {
                        id
                        variantType
                    }
                    submittedTask {
                        id
                        status
                    }
                }
            }
            customItems: learningPathItems(filter: "custom") {
                id
                type
                title
                miles
                earnedMiles
                icon
                url
                complete
                active
                undecided
                redo
                finishDatetime
            }
        }
    }
`);

export type ILearningPath = ResultOf<typeof query>["learningPath"];
export type ILearningPathItem = ILearningPath["learningPathItems"][number];
export type ICustomItem = ILearningPath["customItems"][number];
